// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import Routes from "./Routes";
import SmoothScroll from "./components/SmoothScroll";
import "./index.css";

function App() {
  useEffect(() => {
    // Add smooth scrolling behavior to the entire app
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Add modern scrollbar styling
    const style = document.createElement('style');
    style.textContent = `
      * {
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
      }
    `;
    document.head.appendChild(style);

    // Cleanup
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Provider store={store}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <SmoothScroll>
          <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 font-sans transition-all duration-500 ease-out">
            <div className="animate-fade-in">
              <Routes />
            </div>
          </div>
        </SmoothScroll>
      </Router>
    </Provider>
  );
}

export default App;
